/**
 * Core Modules Index
 */

// Utilities
import debug from "debug";
const MODULE_NAME = 'modules';
const log = debug(MODULE_NAME);

// Dependencies
import * as contentExpand from './content-expand';
import * as modal from './modal';

import * as sticky from './sticky/sticky';
import * as licencePing from './licence-ping/exec';
import * as locationAutocomplete from './location-autocomplete';
import * as tables from './tables';
import navigation from './navigation';
import alerts from './alerts';
import epiforms from './epiforms';
import searchDropdown from './search-dropdown';
import carouselBlock from "./carousel-block";
import immediateCoverTypesBlock from "./immediate-cover-types-block";

import './quote-cta/index--split';
import "./date-field/index--split";
import "./product-card/index--split";
import "./required-field/index--split";
import "./localize-date";
import "./collapsible-escape";
import "./tooltip/tooltip";

// Export
export function exec () {
	log('Running...');
	contentExpand.exec();
	modal.exec();
	sticky.exec();
	locationAutocomplete.exec();
	tables.exec();
	carouselBlock();
	immediateCoverTypesBlock();
	alerts();
	navigation();
	epiforms();
	searchDropdown();
}

export {
	exec as default,
	contentExpand,
	modal,
	sticky,
	licencePing,
	locationAutocomplete,
	tables,
	navigation,
	alerts,
	carouselBlock,
	immediateCoverTypesBlock
};



// WEBPACK FOOTER //
// ./project/client/src/core/modules/index.js